import React from "react";
import { PageHero } from "../components/Shared";
import { CalendarCheck, Facebook, Mail, MessageCircle, Phone } from "lucide-react";

const FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfSIK4POVWHP58Gqtg4q8-vJDVwgrsp3VWKxbIFJux7ubpyWg/viewform?usp=header";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <PageHero
        label="Contact"
        title="Écrivez-nous, rencontrons-nous"
        subtitle="Une question, une remarque ou l'envie de nous rejoindre ? Notre équipe vous répond."
      />

      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-24">
        <div className="grid gap-6">
          <a
            href="mailto:alsaceforte@mail.fr"
            data-testid="contact-email"
            className="flex items-center gap-5 bg-white border border-slate-200/70 rounded-2xl p-7 hover:-translate-y-0.5 hover:shadow-lg transition-all duration-300"
          >
            <span className="w-14 h-14 rounded-xl bg-[#12495B] text-[#F5C518] flex items-center justify-center shrink-0">
              <Mail size={24} />
            </span>
            <div>
              <p className="font-display text-2xl text-[#12495B]">Par email</p>
              <p className="text-[#4B5563] mt-1 font-semibold">alsaceforte@mail.fr</p>
            </div>
          </a>

          <a
            href="tel:+33777971022"
            data-testid="contact-phone"
            className="flex items-center gap-5 bg-white border border-slate-200/70 rounded-2xl p-7 hover:-translate-y-0.5 hover:shadow-lg transition-all duration-300"
          >
            <span className="w-14 h-14 rounded-xl bg-[#12495B] text-[#F5C518] flex items-center justify-center shrink-0">
              <Phone size={24} />
            </span>
            <div>
              <p className="font-display text-2xl text-[#12495B]">Par téléphone</p>
              <p className="text-[#4B5563] mt-1 font-semibold">07 77 97 10 22</p>
            </div>
          </a>

          <a
            href="https://wa.me/33777971022"
            target="_blank"
            rel="noreferrer"
            data-testid="contact-whatsapp"
            className="flex items-center gap-5 bg-[#25D366] rounded-2xl p-7 hover:-translate-y-0.5 hover:shadow-lg transition-all duration-300"
          >
            <span className="w-14 h-14 rounded-xl bg-white/20 text-white flex items-center justify-center shrink-0">
              <MessageCircle size={24} />
            </span>
            <div>
              <p className="font-display text-2xl text-white">Par WhatsApp</p>
              <p className="text-white/90 mt-1 font-semibold">Écrivez-nous directement au 07 77 97 10 22</p>
            </div>
          </a>

          <a
            href="https://www.facebook.com/patrick.striby"
            target="_blank"
            rel="noreferrer"
            data-testid="contact-facebook"
            className="flex flex-col items-center gap-3 bg-[#1877F2] rounded-2xl p-7 hover:-translate-y-0.5 hover:shadow-lg transition-all duration-300 text-center"
          >
            <p className="font-display text-2xl text-white">Suivez également notre campagne sur</p>
            <span className="w-16 h-16 rounded-full bg-white text-[#1877F2] flex items-center justify-center">
              <Facebook size={34} fill="currentColor" />
            </span>
          </a>

          <a
            href={FORM_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="contact-rdv-link"
            className="flex items-center gap-5 bg-[#99142C] border-t-4 border-[#F5C518] rounded-2xl p-7 hover:-translate-y-0.5 hover:shadow-lg transition-all duration-300"
          >
            <span className="w-14 h-14 rounded-xl bg-white/15 text-[#F5C518] flex items-center justify-center shrink-0">
              <CalendarCheck size={24} />
            </span>
            <div>
              <p className="font-display text-2xl text-white">Demander une rencontre</p>
              <p className="text-white/85 mt-1">ou un rendez-vous téléphonique — via notre formulaire en ligne</p>
            </div>
          </a>
        </div>
      </section>
    </div>
  );
}
